import { memo } from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';
import { toIsoString } from 'helpers';
import ErrorWrapper from '../ErrorWrapper/ErrorWrapper';


const BaseDatePicker = ({ label, margin = 'none', fullWidth = false, value, error = false, helperText = '', maxDate, minDate, onChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        maxDate={maxDate}
        minDate={minDate}
        label={label}
        value={value}
        onChange={newValue => {
          onChange({
            value: !!newValue && newValue?.toString() !== 'Invalid Date' ?  toIsoString(newValue): '',
            formattedValue: newValue,
            error: newValue?.toString() === 'Invalid Date' ? 'Date is invalid' : ''
          })
        }}
        renderInput={params =>
          <TextField
            error={error}
            helperText={helperText}
            fullWidth={fullWidth}
            margin={margin}
            {...params}
          />
        }
      />
    </LocalizationProvider>
  );
};

BaseDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),
  fullWidth: PropTypes.bool,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
  error: PropTypes.bool,
  helperText: PropTypes.string,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <BaseDatePicker {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);